import { Container, Button, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import ApplicationForm from "../components/ApplicationForm";

const NewApplicationPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      
      {/* BACK BUTTON */}
      <Box sx={{ mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/")}
        >
          Back to User List
        </Button>
      </Box>

      <ApplicationForm />
    </Container>
  );
};

export default NewApplicationPage;
